import React, { Component } from 'react';
 
class OpcionBuscadorModelos extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
    }

    componentWillUnmount() {
        $('.tooltip').tooltip().hide();
    }


    render() {
        const {
            modelo
        } = this.props;

        //ACTIONS
        const {
            guardarQuitarModeloSeleccionado
        } = this.props;


        let descripcionModelo = modelo.Codigo + " - " + modelo.Descripcion;
        let descripcionModeloCortado = descripcionModelo.length > 36 ? descripcionModelo.substring(0, 35) + String.fromCharCode(8230) : descripcionModelo;
        
        return (
            <div className="ABMModelos__opcionBuscadorCuentasContables ContabilizadorRecontabilizador__opcionesBuscadorModelosContables" 
                 data-toggle="tooltip" 
                 data-title={descripcionModelo}
                 data-placement="right" 
                 data-original-title=""
                 onClick={() => guardarQuitarModeloSeleccionado(modelo.Codigo, true)}
                 title="">
                {descripcionModeloCortado}
            </div>
        );
    }
};

export default OpcionBuscadorModelos
